import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { MapPin, Clock } from "lucide-react";

export default function Career() {
  const [jobs, setJobs] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("All Categories");
  const [shiftFilter, setShiftFilter] = useState("All Shifts");

  useEffect(() => {
    fetch("https://newwaysecurity.com/fetch_jobs.php")
      .then((res) => res.json())
      .then((data) => {
        console.log("Fetched jobs:", data);
        setJobs(data);
      })
      .catch((err) => console.error("Failed to fetch jobs:", err));
  }, []);

  const filteredJobs = jobs.filter((job) => {
    const matchesSearch = job.title
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    const matchesCategory =
      categoryFilter === "All Categories" || job.type === categoryFilter;
    const matchesShift =
      shiftFilter === "All Shifts" ||
      job.shift.toLowerCase().includes(shiftFilter.toLowerCase());

    return matchesSearch && matchesCategory && matchesShift;
  });

  return (
    <div className="text-gray-800">
      <section className="bg-red-800 text-white py-20 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto px-6"
        >
          <h1 className="text-4xl md:text-6xl font-bold mb-4">
            Join Our Security Team
          </h1>
          <p className="text-lg md:text-xl">
            Explore rewarding careers in security and protection services across
            Ontario.
          </p>
        </motion.div>
      </section>

      <section className="bg-white py-6 px-6 shadow-sm">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row gap-4 md:justify-between">
          <input
            type="text"
            placeholder="Search by position..."
            className="border px-4 py-2 rounded-md w-full md:w-1/3"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <select
            className="border px-4 py-2 rounded-md w-full md:w-1/4"
            value={categoryFilter}
            onChange={(e) => setCategoryFilter(e.target.value)}
          >
            <option>All Categories</option>
            <option>On-Site</option>
            <option>Mobile Unit</option>
            <option>Monitoring</option>
            <option>Front Desk</option>
          </select>
          <select
            className="border px-4 py-2 rounded-md w-full md:w-1/4"
            value={shiftFilter}
            onChange={(e) => setShiftFilter(e.target.value)}
          >
            <option>All Shifts</option>
            <option>Day</option>
            <option>Night</option>
            <option>Rotating</option>
          </select>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 lg:grid-cols-2 gap-8">
          {filteredJobs.length > 0 ? (
            filteredJobs.map((job, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
                className="bg-white p-6 rounded-2xl shadow-md hover:shadow-lg hover:scale-105 transition-all relative"
              >
                <div className="absolute top-20 right-5 w-32 h-16 bg-red-800 rounded-full blur-2xl opacity-30 z-0"></div>
                <div className="mb-3 text-red-800 font-semibold text-sm uppercase flex items-center space-x-2">
                  <span className="w-4 h-4 bg-red-800 rounded-full"></span>
                  <span>{job.type}</span>
                </div>
                <h3 className="text-xl font-bold mb-2">{job.title}</h3>
                <div className="flex items-center text-sm text-gray-600 mb-2">
                  <MapPin className="w-4 h-4 mr-2 text-red-800" />
                  {job.location}
                </div>
                <div className="flex items-center text-sm text-gray-600 mb-4">
                  <Clock className="w-4 h-4 mr-2 text-red-800" />
                  {job.shift}
                </div>
                <a
                  href="ars/gaurd/register.php"
                  className="inline-block mt-auto bg-red-800 text-white px-6 py-2 rounded-full font-medium hover:bg-red-900 transition"
                >
                  Apply Now
                </a>
              </motion.div>
            ))
          ) : (
            <p className="text-center text-gray-500 col-span-2">
              No jobs match your filters.
            </p>
          )}
        </div>
      </section>

      <section className="bg-red-800 text-white py-20 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl mx-auto px-6"
        >
          <h2 className="text-4xl font-bold mb-4">
            Can’t Find the Right Role?
          </h2>
          <p className="mb-8 text-lg">
            Submit your resume and our team will contact you when a suitable
            opportunity opens.
          </p>
          <a
            href="/contact"
            className="bg-white text-red-800 px-8 py-3 rounded-full font-semibold hover:bg-red-100 transition shadow-md"
          >
            Create your account
          </a>
        </motion.div>
      </section>
    </div>
  );
}
